<!-- Boot Sequence -->
<template>

  <!-- Go to the next screen when clicked -->
  <div class="boot-screen stretchy" v-on:click="goNext">

    <!-- Boot sequence GIF -->
    <!--<img class="screenshot" src="../assets/intro.trim.black.gif"/>-->

  </div>

</template>

<style lang="scss">
  .boot-screen {
    img {
      height: 100%;
    }
  }
</style>

<script>

  import config from '../data/config'

  var intro_src = require('../assets/intro.trim.black.gif');

  export default {

    methods: {
      goNext() {
        this.$dispatch('goNext');
      }
    },

    ready() {

      // wait 6 seconds, then dispatch the 'goNext' event
      let delay = config.devMode ? 0 : 6000;
      setTimeout(this.goNext, delay);

      // Force GIF to play (bad news. sorry caching layer)
      var img = new Image();
      img.src = intro_src + '?v='+(+(new Date));
      if(!config.devMode) setTimeout(()=>{
        $('.boot-screen').empty().append($(img).addClass('screenshot'));
      }, 10);
    }

  }
</script>



// WEBPACK FOOTER //
// BootScreen.vue?5681164f